import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  TextField,
  FormControlLabel,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { RootState } from '../../../app/rootReducer';
import {
  deleteTask,
  setIsDeleteModalOpen,
  deleteRecurringTask,
  setOpenEditModal,
  updateTaskForStudent,
  updateRecurringTaskForStudent,
} from '../../../slices/taskSlice';
import theme from '../../../app/theme';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
interface IEditTaskModalProps {}

export const EditTaskModal: React.FC<IEditTaskModalProps> = ({}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const { openEditModal, taskId, isRecurring } = useSelector(
    (state: RootState) => {
      return {
        openEditModal: state.task.openEditModal,
        taskId: state.task.taskId,
        isRecurring: state.task.task?.isRecurring,
      };
    },
    shallowEqual
  );
  const [value, setValue] = React.useState('0');

  const handleClose = () => {
    dispatch(setOpenEditModal(false));
  };

  const handleChangeRadio = (event: any) => {
    let value = event.target.value;
    setValue(value);
  };

  return (
    <div>
      <Dialog
        open={openEditModal}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle
          id='alert-dialog-title'
          style={{
            color: theme.palette.primary.main,
            backgroundColor: 'white',
          }}
        >
          Edit Task
        </DialogTitle>
        <DialogContent
          style={{
            backgroundColor: 'white',
          }}
        >
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to edit this task?
          </DialogContentText>

          {isRecurring && (
            <RadioGroup
              aria-label='gender'
              name='gender1'
              value={value}
              onChange={handleChangeRadio}
              color='primary'
            >
              <FormControlLabel
                value='0'
                control={<Radio color='primary' />}
                label='Edit current instance'
              />
              <FormControlLabel
                value='1'
                control={<Radio color='primary' />}
                label='Edit all instances'
              />
            </RadioGroup>
          )}
        </DialogContent>
        <DialogActions
          style={{
            backgroundColor: 'white',
          }}
        >
          <Button variant='text' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            disabled={loading}
            onClick={async (e) => {
              setLoading(true);
              if (value === '1') {
                await dispatch(updateRecurringTaskForStudent(history));
              } else {
                await dispatch(updateTaskForStudent(history));
              }
              setLoading(false);
            }}
          >
            {loading && (
              <CircularProgress
                style={{ color: '#A3A3A3', marginRight: '0.5rem' }}
                size='0.8rem'
              />
            )}{' '}
            Edit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
